import { useState, useEffect } from "react";
import { ACTIVE_URL } from "@/constants";

const API_BASE = `${ACTIVE_URL}/api`;

export interface PageData {
  title: string;
  content: string;
}

export function usePageContent(slug: string) {
  const [data, setData] = useState<PageData | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(`${API_BASE}/content/${slug}/`)
      .then((r) => r.json())
      .then((d: PageData) => setData(d))
      .catch(console.error)
      .finally(() => setIsLoading(false));
  }, [slug]);

  return { data, isLoading };
}
